// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"review-item_reviewItem__FlFV3","reviewItemImages":"review-item_reviewItemImages__rMrpd"};